import { SELECTED_DISTRIBUTOR } from "./type"

export const selectedDistributor=(data)=>{
    return{
        type: SELECTED_DISTRIBUTOR,
        payload: data

    }
}